<!--添加商品  -->
<template>   
<el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="800px" 
        :before-close="handleClose" append-to-body>
    <el-form :model="ruleForm" :rules="rules" ref="formRef" label-width="100px">                
        <el-row>
            <el-col >
                <el-form-item label="单位名称" prop="name">  
                    <el-input v-model="ruleForm.name" placeholder="请输入单位名称" ></el-input>
                </el-form-item>
            </el-col>           
        </el-row>
        <el-row>           
            <el-col >
                <el-form-item label="单位简介" prop="des">
                    <el-input v-model="ruleForm.des" placeholder="请输入单位简介"></el-input>
                </el-form-item>
                <el-col></el-col>
            </el-col>            
        </el-row>     
        <el-row>           
            <el-col >
                <el-form-item label="单位类型" prop="type">
                    <el-input v-model="ruleForm.type" placeholder="请输入单位类型(比如：协会、俱乐部)" ></el-input>
                </el-form-item>
            </el-col>            
        </el-row>     
        <el-row>               
            <el-col>
                <el-form-item label="单位图片" prop="mainImageUrl" class="form" >
                    <el-upload class="avatar-uploader" ref="coverPicUpload" action="" 
                            list-type="picture-card" accept="image/*" multiple :limit="1" name="file"
                            :file-list="fileList"                             
                            :http-request="handleRequest"
                            :on-change="handleFileChange" 
                            :before-upload="handleBeforeUpload" 
                            :on-error="handleUploadError"
                            :on-exceed="handleExceed"
                            :on-remove="handleRemove">
                            <i class="el-icon-plus" />
                    </el-upload>                   
                </el-form-item>  
                <el-form-item class="red">
                     <span>*图片尺寸：300 x 150</span>
                </el-form-item>
            </el-col>   
        </el-row>
        </el-form>
        <span slot="footer" class="dialog-footer">
            <el-button @click="closeDialog">取消</el-button>
            <el-button type="primary" @click="confirmDialog">确定</el-button>
        </span>

</el-dialog>

</template>    
<script>
export default {
    props:{       
        title:{
            type: String,
            default: ''
        },
        formData: {
            type: Object,
            default:{}
        },
        count: {
            type: Number,
            default: 0
        }
    },
    components:{
        
    },
    data() {
        return {
            dialogTitle: '',            
            ruleForm: {
                name: '',
                index: 0,
                des: '',                
                mainImageUrl: '', 
                type: ''             
            },
            rules: {
                name:[
                    { required: true, message: '请输入单位名称', trigger: 'blur' },
                ],                                            
            },                 
            dialogVisible: true,   
            fileList: [],   
            uploadIndex: 0, 
            uploadedLinksMain: [],
            uploadedLinksText: [],
            uploadedFiles: new Set(), // 记录已上传的文件名（避免重复）   
        }
    },
    created() {
        this.dialogTitle = this.title        
        if(this.dialogTitle === '更新单位'){
            this.ruleForm = {...this.formData}
            // console.log(this.ruleForm)

            if(this.ruleForm.mainImageUrl !== ''){
                let imageObjects = [{
                    id: 0,                        
                    name: this.ruleForm.mainImageUrl,
                    url: this.$global.uploadUrl + this.ruleForm.mainImageUrl,
                }]
                this.fileList = imageObjects
            }           
        }
    },
    mounted() {       
  
    },
    methods: {       
        confirmDialog() {
            this.$refs.formRef.validate((valid) => {
                if (valid) {
                    // 校验通过，传递表单数据到父组件
                    this.handleSubmit()    
                } else {
                    window.scrollTo({
                        top:0,
                        behavior: 'smooth'
                    })
                    console.log('表单校验失败');
                    return false;
                }
            });
        }, 
        handleSubmit(){
            let { name, des, mainImageUrl,index,type } = this.ruleForm       
            let flag =  this.dialogTitle === '更新单位' ? 2 : 1   
            let params = {
                opcode: 43,
                i_no: 33,
                v_name: flag === 2 ? index : this.count+1,
                flag: flag,
                v_caption: name,
                v_summary: des,               
                v_imasges: mainImageUrl,
                v_type: type,
            }         
            console.log(params)
            this.$api.requestAPI(params).then(res =>{
                if(res.IsSuccess){
                    if(this.dialogTitle==='更新单位'){
                        this.$message.success('更新成功')
                    }else{
                        this.$message.success('添加成功')
                    }    
                    this.$emit('confirm');
                    this.closeDialog();        
                }else{
                    this.$message.error(res.Message)
                }
            })
        },   
        // 文件选择变化时的回调
        handleFileChange(file, fileList) {
            // 手动校验文件数量
            if (fileList.length > 9) {
                this.$message.warning('最多只能上传9张图片');
                // 移除超出限制的文件（可选）
                fileList.pop(); // 保留最后选择的9个文件
                this.fileList = fileList.slice(0, 9);
                return;
            }
            this.fileList = fileList; // 更新文件列表     
           
        }, 
        async handleRequest(file, fileList){ 
            try{
                const imageUrl = await this.$help.uploadMoreFileRequest(file)
                this.ruleForm.mainImageUrl = imageUrl
                console.log(imageUrl)
                this.$message.success('上传图片成功');
            }catch (error) {
                console.error('上传失败:', error);
                this.$message.error('上传失败，请重试');
            }
        },
        handleRemove(file, fileList) {
            console.log(file.name)
            this.ruleForm.mainImageUrl = ''
            this.fileList = []
        },
        handleUploadError() {
            this.$message({
                type: "error",
                message: "上传失败",
            });
            this.loading.close();
        },
        handleBeforeUpload() {
            this.loading = this.$loading({
                lock: true,
                text: "上传中",
                background: "rgba(0, 0, 0, 0.7)",
            });
            this.loading.close();
        }, 
        closeDialog() {
            this.resetForm()
            this.$emit('close');
        },
        handleClose(){
            this.resetForm()
            this.$emit('close');
        },   
        resetForm(){
            if (this.$refs.formRef) {
                this.$refs.formRef.resetFields();
            } else {
                console.error('表单组件未找到');
            }
        },
        // 超出限制时的回调（Element UI内置）
        handleExceed() {
            this.$message.warning('最多只能上传9张图片');
        },
    }
}
</script>
<style lang='scss' scoped>
.image {
    position: relative;

    .mask {
    opacity: 0;
    position: absolute;
    top: 0;
    width: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    transition: all 0.3s;
    }

    &:hover .mask {
    opacity: 1;
    }
}
</style>


// WEBPACK FOOTER //
// src/views/admin/components/AddCompany.vue